// fake data map (you can expand this with more MPs)
const mockMPs = {
  1: {
    id: 1,
    name: "Anthony Albanese",
    role: "Prime Minister",
    party: "Australian Labor Party",
    constituency: "Grayndler",
    inOfficeSince: "1996",
    imageUrl: "/assets/backgroundinfo_senate.png", // replace with your actual image path
    topIssues: ["Economic Regulation and Competition"],
  },
  2: {
    id: 2,
    name: "Jane Doe",
    role: "Shadow Minister",
    party: "Liberal Party",
    constituency: "Sydney",
    inOfficeSince: "2010",
    imageUrl: "/assets/backgroundinfo_governor_eneral.png",
    topIssues: ["Education", "Health Policy"],
  },
};

// ✅ Fake fetch function
export const fetchMPById = async (id) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const mp = mockMPs[1];
      if (mp) {
        resolve(mp);
      } else {
        reject(new Error("MP not found"));
      }
    }, 500); // simulate delay
  });
};
